
import { ProfessionData } from '../types/professionTypes';

export const garagiste: ProfessionData = {
  title: "Garagiste",
  slug: "garagiste",
  description: "Solutions spécialisées pour les déchets automobiles",
  icon: "Car",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Huiles usagées",
      description: "Huiles moteur et liquides de freins nécessitant un traitement spécifique.",
      solutions: ["Collecte réglementaire", "Valorisation énergétique"],
      environmentalBenefit: "Protection des sols et nappes phréatiques"
    },
    {
      type: "Batteries et accumulateurs",
      description: "Gestion des batteries au plomb et autres accumulateurs.",
      solutions: ["Bacs anti-acide", "Prise en charge et recyclage"],
      environmentalBenefit: "Récupération du plomb et évitement pollution"
    },
    {
      type: "Pneus usagés",
      description: "Solutions pour la gestion des pneumatiques en fin de vie.",
      solutions: ["Collecte sur site", "Valorisation matière"],
      environmentalBenefit: "Évite l'accumulation et valorise en granulats"
    },
    {
      type: "Pièces métalliques",
      description: "Valorisation des pièces mécaniques, carrosserie et catalyseurs.",
      solutions: ["Bennes dédiées", "Rachat catalyseurs"],
      environmentalBenefit: "Récupération métaux précieux et ferreux"
    }
  ],
  relatedProfessions: ["carrossier", "mecanicien", "concessionnaire"]
};
